export default "__VITE_ASSET__B0zh1cLX__"